import { css } from "@styled-system/css";
import { flex, grid } from "@styled-system/patterns";

export const itemWrapperClass = grid({
	gap: "8",
	gridTemplateColumns: "[1fr]",
	border: "1px solid",
	borderColor: "shade.20",
	paddingY: "12",
	paddingX: "[14px]",
	borderRadius: "4",
	textAlign: "left",
	cursor: "pointer",
	position: "relative",
});

export const itemIconWrapperClass = flex({
	alignItems: "center",
	justifyContent: "center",
});

export const elementTitleWrapper = css({
	ml: "10",
});

export const markMistakesWrapperClass = flex({
	flexWrap: "wrap",
	columnGap: "8",
	rowGap: "12",
	marginTop: "12",
});

export const multipleChoiceWrapperClass = grid({
	gridTemplateColumns: "1",
	marginTop: "12",
	columnGap: "24",
	rowGap: "12",
});

export const itemSheetWrapperClass = css({
	minWidth: "full",
});

export const insightsIconClass = css({
	color: "info.100",
});

export const wrongAnswerTitleClass = css({
	fontWeight: "bold",
	fontSize: "12",
});

export const correctAnswerTitle = css({
	fontWeight: "bold",
	fontSize: "12",
	color: "success.100",
	mb: "4",
});
export const buttonWrapperClass = flex({
	alignItems: "flex-start",
	cursor: "pointer",
});
export const answerWrapperClass = flex({
	alignItems: "center",
	justifyContent: "space-between",
});

export const correctAnswerWrapper = flex({
	backgroundColor: "success.0",
	position: "absolute",
	padding: "10",
	left: "0",
	bottom: "0",
	border: "2px solid white",
	width: "[100%]",
	borderRadius: "4",
});
